import { useLazyQuery, useQuery } from "@apollo/client";
import { useHistory, useParams } from "react-router-dom";
import {
  GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID,
  GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID_SEARCH,
  GET_TRAININGPLAN_BY_ID,
} from "../../../Querys/querys";
import "../Capacitaciones/css/CapacitacionesTP.css";
import { Rating } from "@material-ui/lab";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import SearcherTable from "../components/SearcherTable";
//import VisibilityIcon from "@mui/icons-material/Visibility";
import TableBits from "../../TableBits/TableBits";
import columns from "./components/ColumnsTable";
import Calificacion from "./components/Calificacion";
import FormatDate from "./components/FormatDate";
import MenuList from "./components/MenuList";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Grid } from "@material-ui/core";
import UserFieldTP from "../components/UserFieldTP";
import EstatusTP from "./components/EstatusTP";
import moment from "moment";
const CapacitacionesTP = (props: any) => {
  const { id } = useParams<any>();
  const realId = parseInt(id);
  const history = useHistory();

  const [collaboratorList, setCollaboratorList] = useState([]);
  const [collaboratorListFilter, setCollaboratorListFilter] = useState<any[]>(
    []
  );

  const { data: getTrainingplanById, loading } = useQuery(
    GET_TRAININGPLAN_BY_ID,
    {
      variables: {
        getTrainingplanByIdId: realId,
      },
      fetchPolicy: "no-cache",
    }
  );

  const infoTrainingPlan = getTrainingplanById?.GET_TRAININGPLAN_BY_ID;
  const startTrainingPlan = infoTrainingPlan?.startTrainingPlan;
  const endTrainingPlan = infoTrainingPlan?.endTrainingPlan;
  const dateInitFormat = moment(startTrainingPlan).utc().format("DD/MM/YYYY");
  const dateEndFormat = moment(endTrainingPlan).utc().format("DD/MM/YYYY");
  const infoCursoTrainingPlan =
    getTrainingplanById?.GET_TRAININGPLAN_BY_ID?.cursos;
  console.log("info del plan de capacitacion: ", infoTrainingPlan);
  console.log("info de todos los cursos ", infoCursoTrainingPlan);
  const totalHours = infoCursoTrainingPlan?.reduce(
    (accumulator: any, curso: any) => {
      return accumulator + curso.hours;
    },
    0
  );
  const { data: collaboratorsTrainingPlan } = useQuery(
    GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID,
    {
      variables: {
        idTrainingPlan: realId,
      },
      fetchPolicy: "no-cache",
    }
  );
  console.log(collaboratorsTrainingPlan);

  const [
    getCollaboratorsTrainingPlan,
    { error, data: collaboratorTrainingPlan },
  ] = useLazyQuery(GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID_SEARCH, {
    fetchPolicy: "no-cache",
  });
  const [paginationObj, setPaginationObj] = useState({
    idCurso: id,
    rowsOfPage: 10,
    pageNumber: 0,
    searchTerm: "",
    order: "desc",
    orderBy: "FechaIngreso",
  });

  useEffect(() => {
    if (
      collaboratorsTrainingPlan &&
      collaboratorsTrainingPlan?.GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID
    ) {
      setCollaboratorList(
        collaboratorsTrainingPlan?.GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID
      );
      setCollaboratorListFilter(
        collaboratorsTrainingPlan?.GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID
      );
      console.log(collaboratorListFilter);
    }
  }, [collaboratorsTrainingPlan]);

  useEffect(() => {
    if (
      collaboratorTrainingPlan &&
      collaboratorTrainingPlan?.GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID
    ) {
      setCollaboratorList(
        collaboratorTrainingPlan?.GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID
      );
      setCollaboratorListFilter(
        collaboratorTrainingPlan?.GET_ALL_COLLABORATORS_TRAININGPLAN_BY_ID
      );
    }
  }, [collaboratorTrainingPlan]);

  useEffect(() => {
    let currentPillFD = localStorage.getItem("currentPillFD");
    localStorage.setItem("currentPillFD", String(currentPillFD));
  });
  return (
    <>
      {loading === true ? (
        <div className="c_contenedorPrincipal">
          <div className="contenedorLoadingPrincipal">
            <div className="loadingPrincipal"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="divHeadCurso">
            <div>
              <div className="divTitleCurso">
                <span className="titleCurso">
                  {infoTrainingPlan?.nameTrainingPlan}
                </span>
              </div>
              <div style={{ marginTop: "10px" }}>
                <span className="nameInstructorCurso">
                  Periodo: {dateInitFormat} - {dateEndFormat}
                </span>
              </div>
            </div>
            <div>
              <div>
                <span className="hoursCurso">Horas del plan: {totalHours}</span>
              </div>
              {infoTrainingPlan?.average > 0 ? (
                <div className="starCapacitaciones">
                  <Rating
                    name="half-rating-read"
                    defaultValue={infoTrainingPlan?.average}
                    precision={0.5}
                    readOnly
                  />
                </div>
              ) : (
                <div className="starCapacitaciones">
                  <Rating
                    name="half-rating-read"
                    defaultValue={infoTrainingPlan?.average}
                    precision={0.5}
                    readOnly
                  />
                </div>
              )}
            </div>
          </div>
          <div className="divBodyCurso">
            <div className="descriptionCurse">
              {infoTrainingPlan?.descriptionTrainingPlan}
            </div>
          </div>
          <Box
            display="flex"
            flexDirection="column"
            p={2}
            style={{
              backgroundColor: "white",
              borderRadius: "20px",
            }}
          >
            <Box
              p={1}
              pb={8}
              display="flex"
              flexDirection="row"
              style={{ marginBottom: "-25px" }}
            >
              <Box
                display="flex"
                style={{
                  width: "100%",
                }}
                justifyContent="space-between"
              >
                <SearcherTable
                  label="Buscar por nombre / empresa / sede / área"
                  initState={collaboratorsTrainingPlan}
                  setState={setCollaboratorListFilter}
                  fields={["enterprise", "campus", "area"]}
                  customSearch={(searchTerm: string) => {
                    getCollaboratorsTrainingPlan({
                      variables: {
                        idTrainingPlan: realId,
                        rowsPerPage: paginationObj.rowsOfPage,
                        pageNumber: 0,
                        searchTerm,
                        order: paginationObj.order,
                        orderBy: paginationObj.orderBy,
                      },
                    });
                    setPaginationObj({
                      ...paginationObj,
                      pageNumber: 0,
                      searchTerm,
                    });
                  }}
                />
                {/* <div className="divDetalles">
                  <button className="buttonVerDetalles">
                    <VisibilityIcon className="iconoMenuViewColaborador" />
                    <span className="detallesText">Ver detalles</span>
                  </button>
                </div> */}
              </Box>
            </Box>
            <Box p={1} pb={8}>
              <TableBits
                columns={columns}
                rows={collaboratorListFilter}
                components={[
                  UserFieldTP,
                  null,
                  null,
                  null,
                  EstatusTP,
                  Calificacion,
                  FormatDate,
                  null,
                ]}
                componentOptions={MenuList}
                totalRecords={
                  collaboratorListFilter?.length > 0
                    ? collaboratorListFilter[0]?.totalRows
                    : 0
                }
                getData={async (paginationObj_) => {
                  setPaginationObj((val) => ({
                    ...val,
                    rowsPerPage: paginationObj_.rowsOfPage,
                    pageNumber: paginationObj_.pageNumber,
                  }));
                  getCollaboratorsTrainingPlan({
                    variables: {
                      idTrainingPlan: realId,
                      rowsPerPage: paginationObj_.rowsOfPage,
                      pageNumber: paginationObj_.pageNumber,
                      searchTerm: paginationObj.searchTerm,
                      order: paginationObj.order,
                      orderBy: paginationObj.orderBy,
                    },
                  });
                }}
                updatePaginationObj={(paginationObj_) => {
                  setPaginationObj((val) => ({
                    ...val,
                    order: paginationObj_.order,
                    orderBy: paginationObj_.orderBy,
                  }));
                  getCollaboratorsTrainingPlan({
                    variables: {
                      idTrainingPlan: realId,
                      rowsPerPage: paginationObj.rowsOfPage,
                      pageNumber: paginationObj.pageNumber,
                      searchTerm: paginationObj.searchTerm,
                      order: paginationObj_.order,
                      orderBy: paginationObj_.orderBy,
                    },
                  });
                }}
                customInitialOrderBy="Fecha"
                customInitialOrder="desc"
                customRowsPerPage={10}
                updatePageNumber={paginationObj.pageNumber}
              />
              <Grid
                direction="row"
                container
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  marginTop: "10px",
                }}
              >
                <Grid
                  xs
                  item
                  style={{
                    marginTop: "30px",
                  }}
                >
                  <Grid
                    direction="row"
                    container
                    justify="flex-start"
                    alignItems="center"
                  >
                    <div>
                      <ArrowBackIcon
                        fontSize="small"
                        style={{ color: "#fabb00" }}
                      />
                    </div>
                    <span
                      className="Return"
                      style={{ marginTop: "0px" }}
                      onClick={() => {
                        history.push(`/formacionydesarrollo`);
                      }}
                    >
                      Regresar a "Planes de Capacitaci&oacute;n"
                    </span>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </>
      )}
    </>
  );
};
export default CapacitacionesTP;
